module.exports = {"id":"160129","name":"Reinaldo Casirón","rating":"72","photo":"./data/images/photos/3/160129.png","club":{"name":"Deportes Temuco","logo":"./data/images/clubs/DeportesTemuco.png"},"positions":["MOC","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ReinaldoCasiron0.json
// module id = 3560
// module chunks = 0